import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const USER_GROUPS = {
  GRADUATED: 'GRADUATE',
  EMPLOYER: 'EMPLOYER',
};

export const checkUserPermissions = () => {
  try {
    const user = JSON.parse(localStorage.getItem('me'));
    if (!user || !user.groups) return { isGraduated: false, isEmployer: false, groups: [] };
    
   
    const groups = user.groups.map(group => group.toUpperCase());
    
    return {
      isGraduated: groups.includes(USER_GROUPS.GRADUATED),
      isEmployer: groups.includes(USER_GROUPS.EMPLOYER),
      groups: groups,
    };
  } catch (error) {
    console.error('Erro ao verificar permissões:', error);
    return { isGraduated: false, isEmployer: false, groups: [] };
  }
};


export const ProtectedRoute = ({ children, allowedGroups = [] }) => {
  const { isGraduated, isEmployer } = checkUserPermissions();
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthenticated = (() => {
    try {
      const refresh = localStorage.getItem('refresh_token');
      const me = localStorage.getItem('me');
      return Boolean(refresh && me);
    } catch {
      return false;
    }
  })();

  useEffect(() => {
   
    if (allowedGroups.length === 0) return;

    if (!isAuthenticated) {
      navigate('/account/login', { replace: true, state: { from: location.pathname } });
      return;
    }
    
    const hasAccess = 
      (allowedGroups.includes(USER_GROUPS.GRADUATED) && isGraduated) ||
      (allowedGroups.includes(USER_GROUPS.EMPLOYER) && isEmployer);

    if (!hasAccess) {
  
      navigate('/feed', { replace: true });
    }
  }, [isAuthenticated, isGraduated, isEmployer, allowedGroups, navigate, location.pathname]);

 
  if (allowedGroups.length === 0) return children;
  
  if (!isAuthenticated) return null;

 
  const hasAccess = 
    (allowedGroups.includes(USER_GROUPS.GRADUATED) && isGraduated) ||
    (allowedGroups.includes(USER_GROUPS.EMPLOYER) && isEmployer);

  return hasAccess ? children : null;
};